import * as React from "react";
import { connect } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import {
  Container,
  Dropdown,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { COAService } from "../../Common/Services/COAService";
import cellEditFactory from "react-bootstrap-table2-editor";
import { Utils } from "../../Common/Utilis";
import { CustomerService } from "../../Common/Services/CustomerService";
import { CustomerSearch } from "../../Common/Components/CustomerSearch";
import { FaArrowUpFromBracket, FaCircleMinus, FaCirclePlus, FaEllipsis } from "react-icons/fa6";
import { MdOutlineContentPasteGo } from "react-icons/md";
import { resolve, reject } from "q";
import "../../App.scss";
// import "../Masters/customer.scss";
import { ConfirmationModal } from "../../Common/Components/ConfirmationModal";
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { FiChevronDown } from "react-icons/fi";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { COASearch } from "./COASearch";
import ScrollContainer from "react-indiana-drag-scroll";
import { CommentBox } from "../../Common/Components/CommentBox";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
let routeLeavingGuard: any = null;
let requestInProcess = false;
class COAMasterSlidout extends React.Component<any, any> {
  private customerSearch: any;
  private parentScroll: any;

  constructor(props: any) {
    super(props);
    console.log("propsss",this.props);
    this.parentScroll = React.createRef();
    this.customerSearch = React.createRef();
    this.state = {
      showgrp3:false,
      maingrpload:false,
      grpload:false,
      grp2load:false,
      grp3load:false,
      rowload:false,
      isCadd:this.props.isCadd==undefined ? false : this.props.isCadd,
      customercode:"",
      selectedCustomer:"",
      selectOptions: [
        {
          id: 'Active', name: 'Active'
        },
        { id: 'Inactive', name: 'Inactive' }

      ],
      selectAccountOptions: [
        { id: 'Asset', name: 'Asset' ,accid:1},
        { id: 'Liability', name: 'Liability' ,accid:2},
        { id: 'Equity', name: 'Equity',accid:3 },
        { id: 'Revenue', name: 'Revenue',accid:4 },
        { id: 'Expense', name: 'Expense' ,accid:4}
      ],
      maingrpList:[],
      subgrpList:[],
      subgrpList2:[],
      subgrpList3:[],
      rowList:[],
      formData: {
        accountID: this.props.coainfo.accountID || 0,
        accountCode:"",
        accountName: "",
        accountType: "",
        isActive: true,
        groupid: 0,
        mainGroup: "",
        subgroupid: 0,
        subgroupname: "",
        subgroupid2: 0,
        subgroup2name:"",
        subgroupid3: 0,
        subgroup3name:"",
        linegroupid:0,
        rowtitlename:""
      },
    };

  }

  componentDidMount() {
    if(this.props.coainfo.accountID > 0){ this.getCOA();}
    else {this.setState(prevState => ({formData: { ...prevState.formData,mainGroup: 'Select',subgroupname: 'Select',subgroup2name: 'Select',subgroup3name: 'Select',rowtitlename:"Select"},grp2load:true,grp3load:true,grpload:true,rowload:true}));
  }    
  this.GetMainGrps("");
  this.GetSubGrps3();
  this.GetSubGrps(0);
  this.GetSubGrps2(0);
  this.GetRowtitle(0);
  }

  GetSubGrps = (id:any) => {
    let subgrpList: any = [];

    COAService.GetSubGrps({maingrpid:id})
        .then(async (result: any | null) => {
          if (result != null) {
            result.forEach((element) => {
              let item: any = {};
  
              item.id = element.subGroupID;
              item.name = element.subGroupName;
              subgrpList.push(item);
            });
            subgrpList.push({ id: -2, name: "None" });
            this.setState({ subgrpList:[],grpload:false },()=>{
              this.setState({subgrpList,grpload:true});
            });         
           }else{
            this.setState({grpload:true});
  
          }
          resolve();
        })
        .catch((err: any) => {
          toast.error(`Server Error, ${err}`);
          reject();
        });
    };

    GetSubGrps2 = (id:any) => {
      let subgrpList2: any = [];
  
      COAService.GetSubGrps2({subgrpid:id})
          .then(async (result: any | null) => {
            if (result != null) {
              result.forEach((element) => {
                let item: any = {};
    
                item.id = element.subGroup2ID;
                item.name = element.subGroup2Name;
                subgrpList2.push(item);
              });
              subgrpList2.push({ id: -2, name: "None" });
              this.setState({ subgrpList2:[],grp2load:false },()=>{
                this.setState({subgrpList2,grp2load:true});
              });
            }else{
              this.setState({grp2load:true});
    
            }
            resolve();
          })
          .catch((err: any) => {
            toast.error(`Server Error, ${err}`);
            reject();
          });
      };

      GetRowtitle = (id:any) => {
        let rowList: any = [];
    
        COAService.GetRowtitle({subgrpid:id})
            .then(async (result: any | null) => {
              if (result != null) {
                result.forEach((element) => {
                  let item: any = {};
      
                  item.id = element.id;
                  item.name = element.name;
                  rowList.push(item);
                });
                rowList.push({ id: -1, name: "(Match COA Name)" });
                this.setState({ rowList:[],rowload:false },()=>{
                  this.setState({rowList,rowload:true});
                });
              }else{
                this.setState({rowload:true});
      
              }
              resolve();
            })
            .catch((err: any) => {
              toast.error(`Server Error, ${err}`);
              reject();
            });
        };

      GetSubGrps3 = () => {
        let subgrpList3: any = [];
    
        COAService.GetSubGrps3({})
            .then(async (result: any | null) => {
              if (result != null) {
                result.forEach((element) => {
                  let item: any = {};
      
                  item.id = element.subGroup3ID;
                  item.name = element.subGroup3Name;
                  subgrpList3.push(item);
                });
                subgrpList3.push({ id: -2, name: "None" });
                this.setState({ subgrpList3:[],grp3load:false },()=>{
                  this.setState({subgrpList3,grp3load:true});
                });
              }else{
                this.setState({grp3load:true});
      
              }
              resolve();
            })
            .catch((err: any) => {
              toast.error(`Server Error, ${err}`);
              reject();
            });
        };

  GetMainGrps = (value:any) => {
    let maingrpList: any = [];

    const res = this.state.selectAccountOptions.filter((x) => x.id == value);
    const id = res.length > 0 ? res[0].accid : 0;

    COAService.GetMainGrps({accountid:id})
        .then(async (result: any | null) => {
          if (result != null) {
            result.forEach((element) => {
              let item: any = {};
  
              item.id = element.mainGroupID;
              item.name = element.mainGroupName;
              maingrpList.push(item);
            });
            maingrpList.push({ id: -2, name: "None" });
            this.setState({ maingrpList :[],maingrpload:false},()=>{
              this.setState({ maingrpList,maingrpload:true});
            });
          }else{
            this.setState({maingrpload:true});
  
          }
          resolve();
        })
        .catch((err: any) => {
          toast.error(`Server Error, ${err}`);
          reject();
        });
    };

    saveMainGrp = (value:any) => {
      if(value == ""){
        toast.error("Please select account type.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "userManagementHierarchy"
        });
        return;
      }
      
    const res = this.state.selectAccountOptions.filter((x) => x.id == this.state.formData.accountType);
    const id = res.length > 0 ? res[0].accid : "";

      COAService.SaveMainGrps({name:value,accountid:id})
          .then(async (result: any | null) => {
            if (result != null) {
              const {formData} = this.state;
             
              formData.groupid = result.mainGroupID;
              formData.mainGroup = result.mainGroupName;
              this.setState({ formData},()=>{
               this.GetMainGrps(this.state.formData.accountType);
               toast.success("Main Group added.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "userManagementHierarchy"
              });
              });
            }
            resolve();
          })
          .catch((err: any) => {
            toast.error(`Server Error, ${err}`);
            reject();
          });
      };

      SaveSubGrps = (value:any) => {     
        const {formData} = this.state;
        if(formData.groupid == 0){
          toast.error("Please select main group.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "userManagementHierarchy"
          });
          return;
        }
        COAService.SaveSubGrps({name:value,maingrpid:formData.groupid})
            .then(async (result: any | null) => {
              if (result != null) {
        
                formData.subgroupid = result.subGroupID;
                formData.subgroupname = result.subGroupName;
                this.setState({ formData},()=>{
                 this.GetSubGrps(formData.groupid);
                 toast.success("Sub Group 1 added.", {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  containerId: "userManagementHierarchy"
                });
                });
              }
              resolve();
            })
            .catch((err: any) => {
              toast.error(`Server Error, ${err}`);
              reject();
            });
        };

        SaveRowtitle = (value:any) => {
          const {formData} = this.state;
          if(formData.subgroupid == 0){
            toast.error("Please select sub group 1.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "userManagementHierarchy"
            });
            return;

          }
          COAService.SaveRowtitle({name:value,subgrpid:formData.subgroupid})
              .then(async (result: any | null) => {
                if (result != null) {
       
                  formData.linegroupid = result.id;
                  formData.rowtitlename = result.name;
                  this.setState({ formData},()=>{
                   this.GetRowtitle(formData.subgroupid);
                   toast.success("Row title added.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "userManagementHierarchy"
                  });
                  });
                }
                resolve();
              })
              .catch((err: any) => {
                toast.error(`Server Error, ${err}`);
                reject();
              });
          };

        SaveSubGrps2 = (value:any) => {
          const {formData} = this.state;
          if(formData.subgroupid == 0){
            toast.error("Please select sub group 1.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "userManagementHierarchy"
            });
            return;
          }
          COAService.SaveSubGrps2({name:value,subgrpid:formData.subgroupid})
              .then(async (result: any | null) => {
                if (result != null) {
       
                  formData.subgroupid2 = result.subGroup2ID;
                  formData.subgroup2name = result.subGroup2Name;
                  this.setState({ formData},()=>{
                   this.GetSubGrps2(formData.subgroupid);
                   toast.success("Sub Group 2 added.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "userManagementHierarchy"
                  });
                  });
                }
                resolve();
              })
              .catch((err: any) => {
                toast.error(`Server Error, ${err}`);
                reject();
              });
          };

          SaveSubGrps3 = (value:any) => {
            const {formData} = this.state;
            COAService.SaveSubGrps3({name:value})
                .then(async (result: any | null) => {
                  if (result != null) {
         
                    formData.subgroupid3 = result.subGroup3ID;
                    formData.subgroup3name = result.subGroup3Name;
                    this.setState({ formData},()=>{
                     this.GetSubGrps3();
                     toast.success("Sub Group 3 added.", {
                      position: toast.POSITION.BOTTOM_RIGHT,
                      containerId: "userManagementHierarchy"
                    });
                    });
                  }
                  resolve();
                })
                .catch((err: any) => {
                  toast.error(`Server Error, ${err}`);
                  reject();
                });
            };

            
  getCOA = () => {
  
      COAService.GetCOA({accountid:this.state.formData.accountID})
        .then(async (result: any | null) => {
          if (result != null) {
            const {formData} = this.state;
           
            formData.accountCode = result.accountCode; 
            formData.accountName = result.accountName;
            formData.accountType = result.accountType;
            formData.isActive= result.isActive;

            formData.groupid = result.groupid || 0;
            formData.mainGroup = formData.groupid == 0 ? "Select" : formData.groupid == -2 ? "None" : result.mainGroup;

            formData.subgroupid = result.subgroupid || 0;
            formData.subgroupname = formData.subgroupid == 0 ? "Select" : formData.subgroupid == -2 ? "None" : result.subgroupname;


            formData.subgroupid2 = result.subgroupid2 || 0;
            formData.subgroup2name = formData.subgroupid2 == 0 ? "Select" : formData.subgroupid2 == -2 ? "None" : result.subgroup2name;
  
            
            formData.subgroupid3 = result.subgroupid3 || 0;
            formData.subgroup3name = formData.subgroupid3 == 0 ? "Select" : formData.subgroupid3 == -2 ? "None" : result.subgroup3name;
            

            formData.linegroupid = result.linegroupid || 0;
            formData.rowtitlename = formData.linegroupid == 0 ? "Select" : formData.linegroupid == -1 ? "(Match COA Name)" : result.rowtitlename;

      

            console.log("results updatedDeposits",formData);
     
            this.setState({formData,showgrp3:  result.subgroup2name === "Payroll"},()=>{
              if(result.groupid > 0){this.GetSubGrps(result.groupid);}else{this.setState({grpload:true});};
              if(result.subgroupid > 0){this.GetSubGrps2(result.subgroupid),this.GetRowtitle(result.subgroupid);}else{this.setState({grp2load:true,rowload:true});};
              if(result.accountType !== ""){ this.GetMainGrps(result.accountType);}
            });
  
          }
          resolve();
        })
        .catch((err: any) => {
          toast.error(`Server Error, ${err}`);
          reject();
        });
    };

  updateState = (e: any, index: any, type: any, txtID) => {
    if (this != undefined) {
      let isStateChanged = true;
      let isSaveOpen = true;
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;
      let customerContact = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.customerContact))
      );
      if (type === "firstname") {

        e.preventDefault();

        customerContact[index].firstname = e.target.value;

        this.setState({ customerContact, isStateChanged, isSaveOpen }, () => {
          
          $("input[id^='txtfirstname" + index + "txt']").focus();

          let txtdesc = $("input[id^='txtfirstname" + index + "txt']")[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      if (type === "lastname") {

        e.preventDefault();

        customerContact[index].lastname = e.target.value;

        this.setState({ customerContact, isStateChanged, isSaveOpen }, () => {
          $("input[id^='txtlastname" + index + "txt']").focus();

          let txtdesc = $("input[id^='txtlastname" + index + "txt']")[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      if (type === "title") {

        e.preventDefault();

        customerContact[index].title = e.target.value;

        this.setState({ customerContact, isStateChanged, isSaveOpen }, () => {
          $("input[id^='txttitle" + index + "txt']").focus();

          let txtdesc = $("input[id^='txttitle" + index + "txt']")[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      if (type === "phone") {

        e.preventDefault();

        customerContact[index].phoneno = e.target.value;

        this.setState({ customerContact, isStateChanged, isSaveOpen }, () => {
          $("input[id^='txtphone" + index + "txt']").focus();

          let txtdesc = $("input[id^='txtphone" + index + "txt']")[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      if (type === "email") {

        e.preventDefault();

        customerContact[index].email = e.target.value;

        this.setState({ customerContact, isStateChanged, isSaveOpen }, () => {
          $("input[id^='txtemail" + index + "txt']").focus();

          let txtdesc = $("input[id^='txtemail" + index + "txt']")[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }

      if (type === "IsDefault") {
        e.preventDefault();
        
        if(e.target.checked)
        {
          
          customerContact
          .filter((item) => item.id !== customerContact[index].id)
          .map((item, index) => {
            item.isDefault =false;
            return item;
          });
        customerContact[index].isDefault =true;

       

         
         
        }
      else
      {
        customerContact[index].isDefault =false;
      }
        this.setState({ customerContact, isStateChanged,isSaveOpen }, () => {
        
         
        });
      }
    }
  };



  saveItem = () => {

    this.setState({ isSpinner: true });
     let isFormValid = true;
    const {formData} = this.state;

    if (formData.accountCode.trim() === "") {
          toast.error("Please enter COA.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });
          this.setState({ isSpinner: false });
          return false;
        }
    
        if (formData.accountName.trim() === "") {
          toast.error("Please enter name.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });
          this.setState({ isSpinner: false });
          return false;
        }

        const request = {
          ...formData,
          mainGroup: formData.mainGroup === "Select" ? "" : formData.mainGroup,
          subgroupname: formData.subgroupname === "Select" ? "" : formData.subgroupname,
          subgroup2name: formData.subgroup2name === "Select" ? "" : formData.subgroup2name,
          subgroup3name: formData.subgroup3name === "Select" ? "" : formData.subgroup3name,
          rowtitlename: formData.rowtitlename === "Select" ? "" : formData.rowtitlename,
        };
      

   if (isFormValid) {

    console.log("formmmm",formData);
    // return;
    COAService.SaveCOA(request)
      .then( (result: any | null) => {


        if (result !== null) {
          if(result.digitError){
            toast.error("COA length doesn't matches.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "userManagementHierarchy"
            });
            this.setState({ isSpinner: false,isSaveSpinner:false});
            return;
          }
            if(formData.accountID == 0 ){
              toast.success("COA added successfully.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "userManagementHierarchy"
              });
              this.closeCustomerSlideOut();

            }else{
              toast.success("COA updated successfully.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "userManagementHierarchy"
              });
            }
        }
       this.setState({ isSpinner: false,isSaveSpinner:false});
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        requestInProcess = false;
        reject();
      }
      );
    }
  };



  closeCustomerSlideOut = () => {
    this.props.closeSlideOut(this.state?.shouldReloadMainPage);
  };

  handleSelectedItem1 = (control: any, id: any) => {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        isActive: id
      }
    }));
  };



  handleSelectedItem = (control: any, id: any) => {
    let formData = { ...this.state.formData };
    if (control == 1) {
      formData.accountType = id;
      this.setState({ formData});
      this.GetMainGrps(id);
    } else if (control == 2) {
      let res = this.state.maingrpList.filter((x) => x.id == id);
      let name = res.length > 0 ? res[0].name : "";
      formData.groupid = id;
      formData.mainGroup = name;
      this.setState({ formData });
      this.GetSubGrps(id);
    } else if (control == 3) {
      let res = this.state.subgrpList.filter((x) => x.id == id);
      let name = res.length > 0 ? res[0].name : "";
      formData.subgroupid = id;
      formData.subgroupname = name;
      this.setState({ formData });
        this.GetSubGrps2(id);
        this.GetRowtitle(id);
    }else if (control == 4) {
      let res = this.state.subgrpList2.filter((x) => x.id == id);
      let name = res.length > 0 ? res[0].name : "";
      formData.subgroupid2 = id;
      formData.subgroup2name = name;
      this.setState({ formData ,showgrp3: name === "Payroll"});
    }
    else if (control == 5) {
      let res = this.state.subgrpList3.filter((x) => x.id == id);
      let name = res.length > 0 ? res[0].name : "";
      formData.subgroupid3 = id;
      formData.subgroup3name = name;
      this.setState({ formData });
    } else if (control == 6) {
      let res = this.state.rowList.filter((x) => x.id == id);
      let name = res.length > 0 ? res[0].name : "";
      formData.linegroupid = id;
      formData.rowtitlename = name;
      this.setState({ formData });
    }
  };

  handleChange = (event: any, FieldType: string) => {

    let isStateChanged = true;

    let formData = { ...this.state.formData };

    if (FieldType === "coa") {
      formData.accountCode = event.target.value;
    }
    else if (FieldType === "name") {
      formData.accountName = event.target.value;
    }
    
  
    this.setState({ formData, isStateChanged, isSpinner: false }, () => {

    });
  };

  render() {
    const { permissions } = this.props; 
    const hasAddPermission = permissions && permissions['Chart of Accounts'] ? permissions['Chart of Accounts'].includes('Add COA') : false;
    const hasEditPermission = permissions && permissions['Chart of Accounts'] ? permissions['Chart of Accounts'].includes('Edit COA') : false;

    const {


    } = this.state;


    return (
      <section>
        <div className="details-drawer"
          style={{ minWidth: "75%", width: "992px", maxWidth: "100%" 
          }}
        >
          <ToastContainer
            containerId={"userDetailSlideoutcontainer"}
            autoClose={3000}
          />

          <div className="d-flex">
            {!this.state.isOpenViewer && (
              <div
                className="back-drop1  viewer-panel1 opacity "
                onClick={() => this.closeCustomerSlideOut()}
              ></div>
            )}

            <Container
              fluid

              className="body-sec viewer-panel back-drop p-0 "
              style={{ minWidth: "50%", width: "500px", maxWidth: "100%" , zIndex: "1000"}}

            >
              <div
                className="container-fluid py-1 bg-white d-flex align-items-center  border-bottom round-4"
              >
                <div className="divheader">
                  <h5 className="my-title">
                    {this.state.formData.accountCode == "" ? <span>New COA </span> : <span>COA - {this.state.formData.accountCode}</span>}

                  </h5>


                  <div className="header-popout ml-auto">





                    <div className="container text-center">
                      <div className="row align-items-start">
                        <div className="col">
                        </div>

                        <div className="col">
                          <button
                            type="button"
                            className="btn btn-primary cross"
                            onClick={this.closeCustomerSlideOut}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                                fill="#ffffff"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="scroll"
              >

                <section className="pb-3">

                  <div className="row g-3">

                    <div className="col-12 col-md-12 mt-4" >
                    <Form.Group className="row align-items-center" controlId="coa">
                    <Form.Label className="col-sm-2 col-form-label text-start">
                      COA
                    </Form.Label> 
                        <div className="form-outline w-full col-sm-6">
                          <Form.Control type="text" id="txtCustomer"
                            value={this.state.formData.accountCode}
                            autoComplete='off'
                            disabled={false}
                            onChange={(event: any) =>
                            this.handleChange(event, "coa")}
                          />
                        </div>

                      </Form.Group>

                    </div>





                    <div className="col-12 col-md-12" >
                    <Form.Group className="row align-items-center" controlId="coa">
                    <Form.Label className="col-sm-2 col-form-label text-start">
                      Name
                    </Form.Label> 
                        <div className="form-outline w-full col-sm-6">
                          <Form.Control type="text" id="txtCustomer"
                            value={this.state.formData.accountName}
                            autoComplete='off'
                            disabled={false}
                          //  style= {{ max-width: "600px" }}
                            onChange={(event: any) =>
                              this.handleChange(event, "name")}
                          />
                        </div>

                      </Form.Group>

                    </div>
                    
                    

                  <div className="col-12 col-md-12" >
                  <Form.Group className="row align-items-center" controlId="status">
                    <Form.Label className="col-sm-2 col-form-label text-start">
                    Account Type
                    </Form.Label> 
                    <div className="w-full col-sm-6">
                       <div className="single-select type">
                          <SingleDropdownListWithoutSearch
                          itemList={this.state.selectAccountOptions}
                          handleSelectedItem={this.handleSelectedItem.bind(this, 1)}
                          defaultItem={this.state.formData.accountType}
                          defaultText={"Select Account Type"}
                          defaultName={this.state.formData.accountType}
                          controlID="1"
                          id={"ddlselected"}
                          key="id"       
                        />
                        
                    </div>
                    </div>
                    </Form.Group>

                    </div>

                  <div className="col-12 col-md-12" >
                  <Form.Group className="row align-items-center" controlId="status">
                    <Form.Label className="col-sm-2 col-form-label text-start">
                    Main Group
                    </Form.Label> 
                    <div className="w-full col-sm-6" >
                        <Form.Label style={{width:'100%'}}>
                          {this.state.maingrpload  && this.state.formData.mainGroup !== "" &&
                         <COASearch
                           tabIndex={this.state.tabEnable}
                           itemList={this.state.maingrpList}
                           handleSelectedItem={this.handleSelectedItem.bind(this,2)}
                           defaultItem={this.state.formData.mainGroup}
                           defaultText={"Search"}
                           defaultName={this.state.formData.mainGroup}
                           getjobdata={this.saveMainGrp.bind(this)}
                           controlID="2"
                           id={"maingrpddl"}
                           />
                        }
                        </Form.Label>
                    </div>
                    </Form.Group>

                    </div>
                 
                               
                 

                  <div className="col-12 col-md-12" >
                  <Form.Group className="row align-items-center" controlId="status">
                    <Form.Label className="col-sm-2 col-form-label text-start">
                    Subgroup 1
                    </Form.Label> 
                    <div className="w-full col-sm-6" >
                    <Form.Label style={{width:'100%'}}>
                    {this.state.grpload  && this.state.formData.subgroupname !== "" &&
                          <COASearch
                           tabIndex={this.state.tabEnable}
                           itemList={this.state.subgrpList}
                           handleSelectedItem={this.handleSelectedItem.bind(this,3)}
                           defaultItem={this.state.formData.subgroupname}
                           defaultText={"Search"}
                           defaultName={this.state.formData.subgroupname}
                           getjobdata={this.SaveSubGrps.bind(this)}
                           controlID="3"
                           id={"subgrpddl"}
                           />
                          }
                        </Form.Label>
                        
                    </div>
                    </Form.Group>

                    </div>

                    <div className="col-12 col-md-12" >
                    <Form.Group className="row align-items-center" controlId="status">
                    <Form.Label className="col-sm-2 col-form-label text-start">
                    Subgroup 2
                    </Form.Label> 
                    <div className="w-full col-sm-6" >
                    <Form.Label style={{width:'100%'}}>
                    {this.state.grp2load  && this.state.formData.subgroup2name !== "" &&
                         <COASearch
                           tabIndex={this.state.tabEnable}
                           itemList={this.state.subgrpList2}
                           handleSelectedItem={this.handleSelectedItem.bind(this,4)}
                           defaultItem={this.state.formData.subgroup2name}
                           defaultText={"Search"}
                           defaultName={this.state.formData.subgroup2name}
                           getjobdata={this.SaveSubGrps2.bind(this)}
                           controlID="4"
                           id={"subgrp2ddl"}
                           />
                         }
                        </Form.Label>
                        
                    </div>
                    </Form.Group>

                    </div>

                    {this.state.showgrp3 && 
                     <div className="col-12 col-md-12" >
                    <Form.Group className="row align-items-center" controlId="status">
                    <Form.Label className="col-sm-2 col-form-label text-start">
                    Subgroup 3
                    </Form.Label> 
                    <div className="w-full col-sm-6" >
                    <Form.Label style={{width:'100%'}}>
                    {this.state.grp3load  && this.state.formData.subgroup3name !== "" &&
                         <COASearch
                           tabIndex={this.state.tabEnable}
                           itemList={this.state.subgrpList3}
                           handleSelectedItem={this.handleSelectedItem.bind(this,5)}
                           defaultItem={this.state.formData.subgroup3name}
                           defaultText={"Search"}
                           defaultName={this.state.formData.subgroup3name}
                           getjobdata={this.SaveSubGrps3.bind(this)}
                           controlID="5"
                           id={"subgrp2ddl"}
                           />
                         }
                        </Form.Label>
                        
                    </div>
                    </Form.Group>

                    </div>
                    }

                     <div className="col-12 col-md-12" >
                    <Form.Group className="row align-items-center" controlId="status">
                    <Form.Label className="col-sm-2 col-form-label text-start">
                    Row title
                    </Form.Label> 
                    <div className="w-full col-sm-6" >
                    <Form.Label style={{width:'100%'}}>
                    {this.state.rowload  && this.state.formData.rowtitlename !== "" &&
                         <COASearch
                           tabIndex={this.state.tabEnable}
                           itemList={this.state.rowList}
                           handleSelectedItem={this.handleSelectedItem.bind(this,6)}
                           defaultItem={this.state.formData.rowtitlename}
                           defaultText={"Search"}
                           defaultName={this.state.formData.rowtitlename}
                           getjobdata={this.SaveRowtitle.bind(this)}
                           controlID="6"
                           id={"subgrp2ddl"}
                           />
                         }
                        </Form.Label>
                        
                    </div>
                    </Form.Group>

                    </div> 

                    <div className="col-12 col-md-12" >
                    <Form.Group className="row align-items-center" controlId="status">
                    <Form.Label className="col-sm-2 col-form-label text-start">
                     Status
                    </Form.Label>                 
                      <div className="single-select type col-sm-6">
                        <Form.Check 
                          type="checkbox"
                          label="Active"
                          checked={this.state.formData.isActive}
                          onChange={(e) => this.handleSelectedItem1(1, e.target.checked)}
                          id="status-checkbox"
                        />
                      </div>
                    </Form.Group>
                  </div>
                  {/* <div className="filter-sec height-572">
                  
                  <br></br>
                  <br></br>

                  </div> */}
                  </div>

                </section>
              

                <div className={"footer-section viewer-panel"}
                  style={{ minWidth: "50%", width: "500px", maxWidth: "100%" }}
                >
                  <div>
                    <div className="d-flex align-items-center justify-content-end height-72">
                      <div className="d-flex align-items-center">
                        {((hasEditPermission && this.state.formData.accountID > 0) || (hasAddPermission && this.state.formData.accountID === 0)) &&
                          (
                            <>
                              <Button
                                variant="primary"
                                type="button"
                                className="space btn btn-primary btn-discard"
                                onClick={this.closeCustomerSlideOut}
                              >
                                Discard
                              </Button>
                              <Button
                                id="btnSave"
                                variant="primary"
                                type="button"
                                onClick={() => this.saveItem()}

                              >
                                {this.state.formData.accountID == 0 ? "Create" : "Update"}
                              </Button>



                            </>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </Container>
          </div>

          1

          {(this.state.isSpinner || this.state.isSaveSpinner) && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}






        </div>

      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId
});

export default connect(mapStateToProps)(COAMasterSlidout);
